function SizeValueRow({ value, isLast, isFirst }) {
    return (
        <div className={`w-[180px] shrink-0 flex items-center justify-center text-nowrap font-normal text-[16px] leading-[22px] text-[#121212] px-6 py-3 ${isLast && 'border-r rounded-br-lg'} ${isFirst && 'rounded-bl-lg'} border-l border-b`}>
            {value}
        </div>
    )
}

export default SizeValueRow;
